import React from 'react'
import { Box, InputAdornment } from '@mui/material'
import { Loader, TextField as UITextField } from '@carsys/ui'
import { inputBaseClasses } from '@mui/material/InputBase'
import { StepOption } from '../../context/SelectionContext'

interface Props {
  value?: string
  icon?: React.ReactNode
  step: StepOption
  label: string
  disabled: boolean
  currentStep: StepOption
  isLoading: boolean
  onStepChange: (key: StepOption) => void
}

export const SelectedValue: React.FC<Props> = ({ disabled, currentStep, onStepChange, isLoading, value, label, step, icon }) => {
  const active = currentStep === step
  const showLoader = isLoading && active // only show loader for active step
  const fieldSize = 'small'

  return (
    <UITextField
      size={fieldSize}
      disabled={disabled}
      focused={false}
      label={label}
      value={value || ''}
      onClick={() => {
        if (!disabled) {
          onStepChange(step)
        }
      }}
      sx={{ [`& .${inputBaseClasses.input}`]: { cursor: disabled ? 'not-allowed' : 'pointer' } }}
      InputProps={{
        readOnly: true,
        startAdornment:
          (showLoader && (
            <InputAdornment position='start'>
              <Box paddingX={1}>
                <Loader loading size='1rem' />
              </Box>
            </InputAdornment>
          )) ||
          (icon && <InputAdornment position='start'>{icon}</InputAdornment>)
      }}
    />
  )
}

export default SelectedValue
